import { __awaiter, __rest } from "tslib";
import { useEffect, useReducer } from 'react';
import request from '../request';
import { LoadingStates } from '../request/constants';
const ACTIONS = {
    FETCH_INIT: 'FETCH_INIT',
    FETCH_SUCCESS: 'FETCH_SUCCESS',
    FETCH_FAILURE: 'FETCH_FAILURE',
};
const requestReducer = (state, { type, payload }) => {
    switch (type) {
        case ACTIONS.FETCH_INIT:
            return Object.assign(Object.assign({}, state), { status: LoadingStates.Loading });
        case ACTIONS.FETCH_SUCCESS:
            return Object.assign(Object.assign({}, state), { status: LoadingStates.LoadedSuccess, data: payload.data, statusCode: payload.statusCode, error: undefined, headers: payload.headers });
        case ACTIONS.FETCH_FAILURE:
            return Object.assign(Object.assign({}, state), { status: LoadingStates.LoadedFail, error: payload });
        default:
            return state;
    }
};
/**
 *  useRequest    :: request hook that utilizes @pb/utils request functions
 *    url         :: {String}
 *    options     :: {Object}
 *      method    :: {String} 'post' | 'get', defaults to 'get'
 *      data      :: {*} data body for 'post' request
 *      manual    :: {Boolean} don't trigger request, use execute callback fn to manually execute the request!
 *        execute :: {*} if the manual options is set to true then use this execute function to execute the request
 *      rest      :: pass along rest of the options to @pb/utils.request
 *
 */
const useRequest = (url, options = {}, cancelled) => {
    const { manual, method = 'get' } = options, restOptions = __rest(options, ["manual", "method"]);
    const [state, dispatch] = useReducer(requestReducer, {
        status: LoadingStates.NotLoaded,
    });
    let didCancel = cancelled !== undefined ? cancelled : false;
    const fetchData = (overrideDataToSend) => __awaiter(void 0, void 0, void 0, function* () {
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ type: string; }' is not assign... Remove this comment to see the full error message
        dispatch({ type: ACTIONS.FETCH_INIT });
        try {
            const { data, status, headers } = yield request[method](url, Object.assign(Object.assign({}, restOptions), (overrideDataToSend && { data: overrideDataToSend })));
            if (!didCancel) {
                dispatch({ type: ACTIONS.FETCH_SUCCESS, payload: { data, statusCode: status, headers } });
            }
        }
        catch (error) {
            if (!didCancel) {
                dispatch({ type: ACTIONS.FETCH_FAILURE, payload: error });
            }
        }
    });
    useEffect(() => {
        if (!manual && !didCancel) {
            fetchData();
        }
        return () => {
            didCancel = true;
        };
    }, [url]);
    return {
        data: state.data,
        loading: state.status === LoadingStates.Loading,
        error: state.error,
        execute: (data) => fetchData(data),
        isRequestMade: state.status !== LoadingStates.NotLoaded,
        statusCode: state.statusCode,
        headers: state.headers,
    };
};
export default useRequest;
//# sourceMappingURL=useRequest.js.map